import {ERequestType} from 'shared/types/requests';
import {performRequest} from 'shared/utils';

import {
    TDocumentUploadTemplateConfiguratorConverted,
    IDocumentUploadTemplateData, IDocumentUploadTemplateTypeLookupData,
} from './document-upload-template-slice-type';

export type TFetchDocumentUploadTemplateArgs = {
  entityName: string;
  templateCode: string;
};
export const fetchDocumentUploadTemplateData = ({
    entityName,
    templateCode,
}: TFetchDocumentUploadTemplateArgs) => (
    performRequest<IDocumentUploadTemplateData>({
        url: `${entityName}/${templateCode}`,
        method: ERequestType.GET,
    })
);

export type TPostDocumentUploadTemplateConfigurationArgs = {
    url: string;
    data: TDocumentUploadTemplateConfiguratorConverted;
}
export const postDocumentUploadTemplateConfiguration = async (args: TPostDocumentUploadTemplateConfigurationArgs) => {
    const {data, url} = args;

    const response = await performRequest({
        url,
        method: ERequestType.POST,
        data,
    });
    return response;
};

export type TPatchDocumentUploadTemplateDataArgs = {
    templateCode: string;
    entityName: string;
    data: Partial<IDocumentUploadTemplateData>;
}
export const patchDocumentUploadTemplate = async (args: TPatchDocumentUploadTemplateDataArgs) => {
    const {templateCode, data, entityName} = args;

    const response = await performRequest({
        url: `${entityName}/${templateCode}`,
        method: ERequestType.PATCH,
        data,
    });
    return response;
};

export type TFetchSettingTemplateTransferTargetColumnsDataArgs = {
    sublistCode: string;
    sublistId?: number;
}
export const fetchSettingTemplateTransferTargetColumns = async (
    args: TFetchSettingTemplateTransferTargetColumnsDataArgs,
) => {
    const {sublistCode, sublistId} = args;
    const response = await performRequest<IDocumentUploadTemplateTypeLookupData[]>({
        url: 'valueLists/DATABASE_TABLE_COLUMNS',
        method: ERequestType.GET,
        params: {sublistCode, sublistId},
    });
    return response;
};

export type TDeleteDocumentUploadTemplateArgs = TFetchDocumentUploadTemplateArgs;
export const deleteDocumentUploadTemplateConfiguration = async ({
    entityName,
    templateCode,
}: TDeleteDocumentUploadTemplateArgs) => {
    const response = await performRequest<string>({
        url: `${entityName}/${templateCode}`,
        method: 'DELETE',
    });
    return response;
};
